import React, { Component } from "react";
import { connect } from "react-redux";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import "./MainLayout.css";
import MenuWrapper from "../components/RepositMenu";

const mapStateToProps = (state) => ({
  routing: state.routing,
});

export class MainLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
      pageAnimation: null,
    };
  }

  componentDidMount = () => {
    const currentPageStack = this.getPageStack(this.props.children.props);
    const currentPage = currentPageStack[currentPageStack.length - 1];

    this.setState({
      page: currentPage,
    });
  };

  componentWillReceiveProps = (nextProps) => {
    // We assume that the page is only going to chang when the URL changes.
    if (this.props.location.pathname !== nextProps.location.pathname) {
      // // We get the stack for the current props and the next props. We use the
      // // last item in the stack of the nextProps as the next page.
      // const currentPageStack = this.getPageStack(this.props.children.props)[0];
      // const nextPageStack = this.getPageStack(nextProps);
      // const nextPage = nextPageStack[nextPageStack.length - 1];
      // console.log(currentPageStack, nextPageStack)
      //
      // // Then we compare the length of the current stack vs the next stack,
      // // if the next stack length is lower then we must be going back. If the
      // // stack is bigger then were going forward.
      // let animation;
      // if (nextPageStack[1].depth >= currentPageStack.depth) {
      //   animation = "forward";
      // } else {
      //   animation = "back";
      // }
      //
      // this.setState({
      //   page: nextPage,
      //   pageAnimation: animation
      // });
      let forward, backward;

      const currentPage = this.props.children.props;
      const nextPage = nextProps.children.props;

      const pageKeys = [currentPage.route.pageKey, nextPage.route.pageKey];

      if (
        pageKeys.includes("ComponentList") &&
        pageKeys.includes("InverterSets")
      ) {
        forward = "up";
        backward = "down";
      } else {
        forward = "forward";
        backward = "back";
      }

      const animation =
        currentPage.route.depth < nextPage.route.depth ? forward : backward;

      this.setState({
        page: {
          component: nextPage.route.component,
          key: nextPage.route.pageKey,
        },
        pageAnimation: animation,
      });
    }
  };

  getPageStack = (props, pageStack) => {
    // This recurses down through all the children and builds a stack of all
    // the pageComponents in the component hierarchy. This can then be used
    // to determine how deep the current page is.
    if (!pageStack) pageStack = [];
    if (props.route && props.route.component) {
      pageStack.push({
        depth: props.route.depth,
        component: props.route.component,
        key: props.route.pageKey,
      });
    }
    if (props.children) {
      return this.getPageStack(props.children.props, pageStack);
    } else {
      return pageStack;
    }
  };

  render() {
    let enter = "",
      enterActive = "",
      leave = "",
      leaveActive = "";

    const page = this.state.page;

    // The side-bar animation needs to swipe left when going to a sub-menu and
    // swipe right when returning to the main menu. There are two sets of styles
    // to handle this and the sets are swapped in/out here based on the route.
    switch (this.state.pageAnimation) {
      case "forward":
        enter = "page-enter-non-root";
        enterActive = "page-enter-active-non-root";
        leave = "page-leave-non-root";
        leaveActive = "page-leave-active-non-root";
        break;
      case "back":
        enter = "page-enter";
        enterActive = "page-enter-active";
        leave = "page-leave";
        leaveActive = "page-leave-active";
        break;
      case "up":
        enter = "page-up-non-root";
        enterActive = "page-up-active-non-root";
        leave = "page-down-non-root";
        leaveActive = "page-down-active-non-root";
        break;
      case "down":
        enter = "page-up";
        enterActive = "page-up-active";
        leave = "page-down";
        leaveActive = "page-down-active";
        break;
      default:
        break;
    }

    return (
      <div className="main">
        <MenuWrapper>
          {this.state.page ? (
            <div
              className="transition-container"
              style={{ position: "relative" }}
            >
              <ReactCSSTransitionGroup
                transitionEnterTimeout={320}
                transitionLeaveTimeout={320}
                transitionEnter={true}
                transitionLeave={true}
                transitionName={{
                  enter: enter,
                  enterActive: enterActive,
                  leave: leave,
                  leaveActive: leaveActive,
                }}
              >
                {React.createElement(page.component, {
                  key: page.key,
                  params: this.props.params,
                  path: this.props.routing.locationBeforeTransitions.pathname,
                })}
              </ReactCSSTransitionGroup>
            </div>
          ) : null}
        </MenuWrapper>
      </div>
    );
  }
}

export default connect(mapStateToProps)(MainLayout);



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.web.js